import encode64 from "../helpers/encode64";
import consultarInfoToken from "./consultarInfoToken";
import getDatos from "./getDatos";
import getIp from "./getIP";

export default async function guardarUbicacion(
  origen,
  tipo,
  idElemento,
  idCalificacion = 0
) {
  let result = await consultarInfoToken();
  let jsonIp = await getIp();

  try {
    await getDatos("opendata/estadistica/guardarUbicacion", {
      origen: encode64(String(origen)),
      tipo: encode64(String(tipo)),
      idUser: encode64(String(result.idUsuario)),
      idElemento: encode64(String(idElemento)),
      idCalificacion: encode64(String(idCalificacion)),
      location: encode64(JSON.stringify(jsonIp)),
    });
  } catch (error) {
    console.error(error);
  }
  return "Ok";
}
